const getDeviceByScreenSize = () =>
  window.screen.width > 768 ? 'desktop' : 'mobile';

export default getDeviceByScreenSize;
